export enum MAIN_URLS {
    HOME = '/',
    LOGIN = 'login',
    SIGNUP = 'signup',
    REPORT = 'report',
    MEASUREMENTS = 'measurements',
    CULTIVATIONS = 'cultivations',
    FARMS = 'farms',
    NODES = 'nodes',
    CROP_TEMPERATURE_NODES = 'crop-temperature-nodes',
    WEATHERSTATIONS = 'weather-stations',
    NODES_MAP = 'nodes/map',
    WEATHERSTATIONS_MAP = 'weather-stations/map',
    FIRMWARES = 'firmwares',
    OTA_REQUESTS = 'ota-requests',
    NODE_STATUS = 'node-status',
    FORBIDDEN = 'forbidden',
}

export enum SEARCH_PARAMS {
    DEVICE_TYPE = 'device-type',
    FARM_ID = 'farm-id',
    CULTIVATION_ID = 'cultivation-id',
}
